// extracted by mini-css-extract-plugin
export default {"file":"attachment_file__O0MB-","type":"attachment_type__DSYcu","actions":"attachment_actions__Z2AZz"};